import { render, staticRenderFns } from "./ProjectBase.vue?vue&type=template&id=26e45a6b&"
import script from "./ProjectBase.vue?vue&type=script&lang=js&"
export * from "./ProjectBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports